import { RegisterClass } from "core/Misc/typeStore";
import { Quaternion } from "core/Maths/math.vector";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";

export class RewardInverseRotationBlock extends RewardGraphNode {
    public constructor(name: string) {
        super(name);

        this.registerInput("rotation", RewardGraphConnectionPointTypes.Quat);
        this.registerOutput("inverse", RewardGraphConnectionPointTypes.Quat);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardInverseRotationBlock";
    }

    /**
     * Gets the left input component
     */
    public get rotation(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the reward output component
     */
    public get inverse(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        let func: (state: RewardGraphBuildState) => any;

        if (!this.rotation.isConnected) {
            this.inverse._storedFunction = null;
            this.inverse._storedValue = null;
            return;
        }

        func = (state) => {
            const input = this.rotation.getConnectedValue(state) as Quaternion;
            return input.invert();
        }

        this.inverse._storedFunction = (state) => {
            return func(state);
        };
    }
}

RegisterClass("MELS.RewardInverseRotationBlock", RewardInverseRotationBlock);
